@if (isCustomerHost) {
  <!-- A customer host: signed in, but not a member of this organization —
       whether Auth0 refused the account outright or the token names a
       different organization. Board 7f. -->
  <app-auth-layout
    art="wrong-key"
    [branded]="true"
    [animated]="true"
    headline="You're at the right address."
    blurb="This portal belongs to one organization. Sign in with the account that organization registered and everything here is yours."
  >
    <!-- Featured: the customer's logo leads, with motion. No incident code —
         the fix is being added by their admin or account manager, not a ticket. -->
    <app-access-denied
      [featured]="true"
      [logoUrl]="branding().logoUrl"
      [logoAlt]="branding().displayName"
      [eyebrow]="branding().displayName + ' · Davaco Customer Portal'"
      heading="No access to this organization"
      advisory="Ask your organization's admin or your Davaco account manager to add you, or sign in with the account your organization registered."
      actionLabel="Try another account"
      (action)="signOut()"
    >
      @if (email() !== '') {
        <b>{{ email() }}</b> isn't a member of {{ branding().displayName }} on the Davaco
        Customer Portal.
      } @else {
        Your account isn't a member of {{ branding().displayName }} on the Davaco Customer
        Portal.
      }
    </app-access-denied>
  </app-auth-layout>
} @else {
  <!-- The apex: a Davaco employee without the Davaco Admin role. -->
  <app-auth-layout
    art="locked"
    headline="Rollouts, as they stand today."
    blurb="Davaco staff can see every customer organization, review sign-in activity and view the portal as any customer sees it."
  >
    <app-access-denied
      [logoUrl]="branding().logoUrl"
      [logoAlt]="branding().displayName"
      eyebrow="Davaco Customer Portal"
      heading="No access"
      advisory="Ask a portal administrator to grant your account the Davaco Admin role. Signing in again won't change anything until they do."
      actionLabel="Sign in with another account"
      [code]="'admin_role_required · ref ' + reference()"
      (action)="signOut()"
    >
      @if (email() !== '') {
        <b>{{ email() }}</b> is signed in, but doesn't have the Davaco Admin role this portal
        requires.
      } @else {
        Your account is signed in, but doesn't have the Davaco Admin role this portal requires.
      }
    </app-access-denied>
  </app-auth-layout>
}
